// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"KW-z","sponsoredTooltipWrapper":"LW-z","sponsoredTooltip":"MW-z","newCard":"NW-z"};